import React, { ReactNode } from 'react';
import { LayerPosition } from '../../types';

interface Props {
    children: ReactNode;
    style: LayerPosition;
}


const Wrapper: React.FC<Props> = ({
    children,
    style,
}) => {
    const wrapperClassName = "poplayer";

    return (
        <div
            id="popupBox"
            className={wrapperClassName}
            style={style}
        >
            {children}
        </div>
    )
}

export default Wrapper;